import React from 'react';
import { connect } from 'react-redux';
import { ShowIf } from 'components/utils';
import { DropDownChonCanBoXuLy, DropDownMulipleUse } from 'components/tt-forms';
import { processType } from 'constants/process-type';
import { LetterProcessingWorkFlow } from 'api';
import { validatable } from 'components/utils';
import { msg } from 'constants/message';

const process = [processType.xuLyDon.processing.truongPhongGiaoViecChuyenVien, processType.xuLyDon.processing.deXuatGiaoViecLai];

class TruongPhongGiaoViecPU extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      form_TruongPhongGiaoViecCanBo: false,
      form_DeXuatGiaoViecLai: false,

      donId: this.props.donId,

      numberState: 0,
      onlyState: '',

      nextState: '',

      hideDropdown: false,

      phongBan: this.props.userInfo.coQuanQuanLyId,
      canBoChiDinh: '',
      listNextStates: []
    }
  }

  componentWillMount() {
    this.checkState();
  }

  checkState() {

    let numberState = 0;
    let onlyState = '';

    process.map((item, i) => {
      if (this.props.getState(this.props.listNextStates, item)) {

        onlyState = item;
        numberState++;

        switch (item) {
          case processType.xuLyDon.processing.truongPhongGiaoViecChuyenVien:
            this.setState({
              onlyState: onlyState,
              numberState: numberState,
              form_TruongPhongGiaoViecCanBo: true
            })
          break;
          case processType.xuLyDon.processing.deXuatGiaoViecLai:
            this.setState({
              onlyState: onlyState,
              numberState: numberState,
              form_DeXuatGiaoViecLai: true
            })
          break;
        }
      }
    });
  }

  componentDidMount() {

    this.onlyOneState();
    if (this.state.donId != 0) {
      this.getThongTinXuLy(this.state.donId);
    }

    if(this.props.listNextStates) {
      let data = [...this.props.listNextStates];
      let dataFilter = data.filter(props => {
        return props.type != 'CAN_BO_GIAO_DON_VI_TTXM_LAP_DU_THAO'
      })

      let dataNextState = [...dataFilter];
      let dataNextStateFilter = [];

      dataNextState.map(item => {
        let newItem = item;
        if (item.type == 'KET_THUC') {
          newItem.tenVietTat = 'Tự xử lý';
          newItem.ten = 'Trưởng phòng tự xử lý';
        }
        dataNextStateFilter[dataNextStateFilter.length] = newItem;
      })
      this.setState({
        listNextStates: dataNextStateFilter
      })
    }


  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.listNextStates) {
      let data = [...nextProps.listNextStates];
      let dataFilter = data.filter(props => {
        return props.type != 'CAN_BO_GIAO_DON_VI_TTXM_LAP_DU_THAO'
      })

      let dataNextState = [...dataFilter];
      let dataNextStateFilter = [];

      dataNextState.map(item => {
        let newItem = item;
        if (item.type == 'KET_THUC') {
          newItem.tenVietTat = 'Tự xử lý';
          newItem.ten = 'Trưởng phòng tự xử lý';
        }
        dataNextStateFilter[dataNextStateFilter.length] = newItem;
      })
      this.setState({
        listNextStates: dataNextStateFilter
      })
    }
  }

  onlyOneState() {

    if (this.state.numberState == 1) {
      let newState = {
        ...this.state,
        nextState: this.state.onlyState,
        hideDropdown: true,
      }

      this.setState({
        ...newState
      }, this.trigger(newState, true));
    }
  }

  getThongTinXuLy(donId) {
    LetterProcessingWorkFlow.actions.getThongTinXuLy.request({ id: donId }).then(res => {
      if (res.data) {
        let info = res.data.thongTinXuLyInfo;

        let newState = { ...this.state };

        if (typeof info.nextState != 'undefined') {
          newState = {
            ...this.state,
            canBoChiDinh: '',
            noiDung: ''
          }
        }

        this.setState({
          ...newState
        });

        this.trigger(newState, true);
      }
    })
  }

  handleChange(name, e) {

    let newState = {
      ...this.state,
      [name]: e.target.value
    }

    this.setState({
      ...newState
    }, ()=> {
      if (name == 'nextState') {

      }
      this.trigger(newState, false)
    });
  }

  trigger(newState, isInit) {

    if (newState.nextState) {

      let stateId = this.props.getState(this.props.listNextStates, newState.nextState);

      let params = {
        nextState: {
          id: Number(stateId)
        },
        nextStateType: newState.nextState
      }

      if (newState.form_TruongPhongGiaoViecCanBo && newState.nextState == processType.xuLyDon.processing.truongPhongGiaoViecChuyenVien) {

        params.notice = msg.xldTruongPhongGiaoViec;

        if (newState.canBoChiDinh) {
          params.canBoXuLyChiDinh = {
            id: Number(newState.canBoChiDinh)
          }
        }
      } else if (newState.form_DeXuatGiaoViecLai && newState.nextState == processType.xuLyDon.processing.deXuatGiaoViecLai) {
        params.notice = msg.xldTruongPhongGiaoViec;
      }

      this.props.onChange(params, isInit);
    } else {

      let params = {}

      this.props.onChange(params, isInit);
    }
  }
  render() {
    return (
      <div className="body-dialog-gh">
        <ShowIf condition={this.props.listNextStates.length == 1}>
          <span className='col-100 text-13 pt25 pl20 pb10'>{this.props.content}</span>
        </ShowIf>
        <div className="row pl30 pr30 pt20">
          <ShowIf condition={this.props.listNextStates.length > 1}>
            <DropDownMulipleUse
              className="col-50"
              require
              data={this.state.listNextStates}
              bindValidator={this}
              selectedValue={this.state.nextState}
              label="Hướng giải quyết"
              name="huongGiaiQuyet"
              keyName='type'
              valueName='tenVietTat'
              onChange={this.handleChange.bind(this, 'nextState')}
            />
          </ShowIf>
          <ShowIf condition={this.state.nextState == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO'}>
            <DropDownChonCanBoXuLy require
              className="col-50"
              bindValidator={this}
              isValid={this.props.validate}
              selectedValue={this.state.canBoChiDinh}
              phongBanId={this.state.phongBan}
              vaiTro="CHUYEN_VIEN"
              onChange={this.handleChange.bind(this, 'canBoChiDinh')}
              name="dropdownTruongPhongChonCanBoXuLy" />
          </ShowIf>
        </div>
      </div>
    );
  }
}

TruongPhongGiaoViecPU.defaultProps = {
  listNextStates: [],
  validate: false,
  onChange: function () {
    console.log('Need to assign onChange method');
  },
  getState: function () {
    console.log('Need to assign getState method');
  }
}

function bindStateToProps(state) {
  return {
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
  }
}

export default connect(bindStateToProps)(validatable(TruongPhongGiaoViecPU));



// WEBPACK FOOTER //
// ./src/components/modules/dialog/thu-hoi-form/TruongPhongGiaoViecPU.jsx